/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Lusca Search
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from "./configuration";
import globalAxios, {
  AxiosPromise,
  AxiosInstance,
  AxiosRequestConfig,
} from "axios";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from "./common";
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from "./base";

/**
 *
 * @export
 * @interface Cbe
 */
export interface Cbe {
  /**
   *
   * @type {string}
   * @memberof Cbe
   */
  orderId?: string;
}
/**
 *
 * @export
 * @interface CreateShadowTestRequest
 */
export interface CreateShadowTestRequest {
  /**
   * Marketplace code (e.g., US, DE)
   * @type {string}
   * @memberof CreateShadowTestRequest
   */
  marketplace: string;
  /**
   * GL Product Group ID
   * @type {string}
   * @memberof CreateShadowTestRequest
   */
  glProductGroupId: string;
  /**
   * List of transaction IDs to test
   * @type {Array<string>}
   * @memberof CreateShadowTestRequest
   */
  transactionIds: Array<string>;
}
/**
 *
 * @export
 * @interface DLQInfoResult
 */
export interface DLQInfoResult {
  /**
   * The status of the DLQ query (e.g., \"pending\", \"completed\", \"failed\")
   * @type {string}
   * @memberof DLQInfoResult
   */
  status: string;
  /**
   * The ID of the query execution (present when status is \"pending\")
   * @type {string}
   * @memberof DLQInfoResult
   */
  queryExecutionId?: string;
  /**
   * Whether the order is in DLQ (present when status is \"completed\")
   * @type {boolean}
   * @memberof DLQInfoResult
   */
  inDLQ?: boolean;
  /**
   * The DLQ items (present when status is \"completed\" and inDLQ is true)
   * @type {Array<DLQItem>}
   * @memberof DLQInfoResult
   */
  dlqItems?: Array<DLQItem>;
  /**
   *
   * @type {string}
   * @memberof DLQInfoResult
   */
  error?: string;
}
/**
 *
 * @export
 * @interface DLQItem
 */
export interface DLQItem {
  /**
   * The primary key of the DLQ item
   * @type {string}
   * @memberof DLQItem
   */
  pk: string;
  /**
   * The name of the queue where the message failed
   * @type {string}
   * @memberof DLQItem
   */
  eventsourcekey: string;
  /**
   * The timestamp when the message failed processing
   * @type {string}
   * @memberof DLQItem
   */
  timestamp: string;
  /**
   *
   * @type {DLQItemProcessedBody}
   * @memberof DLQItem
   */
  processed_body: DLQItemProcessedBody;
  /**
   * Indicates whether the message is a raw string (true) or valid JSON object (false)
   * @type {boolean}
   * @memberof DLQItem
   */
  is_malformed_json: boolean;
}
/**
 * @type DLQItemProcessedBody
 * The message body, either as a raw string (if malformed) or parsed JSON object
 * @export
 */
export type DLQItemProcessedBody = string | { [key: string]: any };

/**
 *
 * @export
 * @interface DLQRedriveInfoResult
 */
export interface DLQRedriveInfoResult {
  /**
   * The status of the DLQ query (e.g., \"PENDING\", \"COMPLETED\", \"ERROR\")
   * @type {string}
   * @memberof DLQRedriveInfoResult
   */
  status: string;
  /**
   * The ID of the redrive execution (present when status is \"PENDING\")
   * @type {string}
   * @memberof DLQRedriveInfoResult
   */
  executionArn?: string;
  /**
   *
   * @type {DLQRedriveInfoResultResult}
   * @memberof DLQRedriveInfoResult
   */
  result?: DLQRedriveInfoResultResult;
  /**
   *
   * @type {string}
   * @memberof DLQRedriveInfoResult
   */
  error?: string;
}
/**
 *
 * @export
 * @interface DLQRedriveInfoResultResult
 */
export interface DLQRedriveInfoResultResult {
  /**
   * Mapping of messageId to status (SUCCESS, DRY_RUN, ERROR, NOT_FOUND)
   * @type {{ [key: string]: any; }}
   * @memberof DLQRedriveInfoResultResult
   */
  redrivenMessages?: { [key: string]: any };
}
/**
 *
 * @export
 * @interface DashboardEmbedResponse
 */
export interface DashboardEmbedResponse {
  /**
   * The URL for embedding the dashboard
   * @type {string}
   * @memberof DashboardEmbedResponse
   */
  embedUrl: string;
  /**
   * The request ID for this embed URL generation
   * @type {string}
   * @memberof DashboardEmbedResponse
   */
  requestId: string;
}
/**
 *
 * @export
 * @interface DetailsResponse
 */
export interface DetailsResponse {
  /**
   *
   * @type {Array<{ [key: string]: any; }>}
   * @memberof DetailsResponse
   */
  events?: Array<{ [key: string]: any }>;
  /**
   *
   * @type {Array<{ [key: string]: any; }>}
   * @memberof DetailsResponse
   */
  cbes?: Array<{ [key: string]: any }>;
}
/**
 *
 * @export
 * @interface DownloadS3FileResponse
 */
export interface DownloadS3FileResponse {
  /**
   * Pre-Signed url for S3 file
   * @type {string}
   * @memberof DownloadS3FileResponse
   */
  url: string;
}
/**
 *
 * @export
 * @interface Event
 */
export interface Event {
  /**
   *
   * @type {string}
   * @memberof Event
   */
  orderId?: string;
}
/**
 *
 * @export
 * @interface ListProjects200Response
 */
export interface ListProjects200Response {
  /**
   *
   * @type {Array<Project>}
   * @memberof ListProjects200Response
   */
  projects?: Array<Project>;
}
/**
 *
 * @export
 * @interface ModelError
 */
export interface ModelError {
  /**
   *
   * @type {number}
   * @memberof ModelError
   */
  code: number;
  /**
   *
   * @type {string}
   * @memberof ModelError
   */
  message: string;
}
/**
 *
 * @export
 * @interface Project
 */
export interface Project {
  /**
   *
   * @type {string}
   * @memberof Project
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof Project
   */
  projectName: string;
  /**
   *
   * @type {string}
   * @memberof Project
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof Project
   */
  createdBy: string;
  /**
   *
   * @type {string}
   * @memberof Project
   */
  createdAt: string;
  /**
   *
   * @type {string}
   * @memberof Project
   */
  lastModifiedBy: string;
  /**
   *
   * @type {string}
   * @memberof Project
   */
  lastModified: string;
  /**
   *
   * @type {Array<ProjectTransaction>}
   * @memberof Project
   */
  transactions: Array<ProjectTransaction>;
  /**
   *
   * @type {number}
   * @memberof Project
   */
  version: number;
  /**
   *
   * @type {boolean}
   * @memberof Project
   */
  isArchived: boolean;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof Project
   */
  metadata?: { [key: string]: any };
}
/**
 *
 * @export
 * @interface ProjectCreate
 */
export interface ProjectCreate {
  /**
   *
   * @type {string}
   * @memberof ProjectCreate
   */
  projectName: string;
  /**
   *
   * @type {string}
   * @memberof ProjectCreate
   */
  description?: string;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof ProjectCreate
   */
  metadata?: { [key: string]: any };
}
/**
 *
 * @export
 * @interface ProjectTransaction
 */
export interface ProjectTransaction {
  /**
   *
   * @type {string}
   * @memberof ProjectTransaction
   */
  transactionId: string;
  /**
   *
   * @type {string}
   * @memberof ProjectTransaction
   */
  txnStatus: string;
  /**
   *
   * @type {string}
   * @memberof ProjectTransaction
   */
  uatStatus: string;
  /**
   *
   * @type {string}
   * @memberof ProjectTransaction
   */
  assignedTo: string;
  /**
   *
   * @type {string}
   * @memberof ProjectTransaction
   */
  addedBy: string;
  /**
   *
   * @type {string}
   * @memberof ProjectTransaction
   */
  addedAt: string;
}
/**
 *
 * @export
 * @interface ProjectUpdate
 */
export interface ProjectUpdate {
  /**
   *
   * @type {string}
   * @memberof ProjectUpdate
   */
  projectName?: string;
  /**
   *
   * @type {string}
   * @memberof ProjectUpdate
   */
  description?: string;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof ProjectUpdate
   */
  metadata?: { [key: string]: any };
  /**
   *
   * @type {boolean}
   * @memberof ProjectUpdate
   */
  isArchived?: boolean;
  /**
   *
   * @type {number}
   * @memberof ProjectUpdate
   */
  version: number;
}
/**
 *
 * @export
 * @interface RecentTransactionsResponse
 */
export interface RecentTransactionsResponse {
  /**
   *
   * @type {Array<Transaction>}
   * @memberof RecentTransactionsResponse
   */
  transactions: Array<Transaction>;
  /**
   * Timestamp to use for fetching the next page of results
   * @type {number}
   * @memberof RecentTransactionsResponse
   */
  nextPageTimestamp?: number;
  /**
   * The CloudWatch Logs Insights query that was executed
   * @type {string}
   * @memberof RecentTransactionsResponse
   */
  executedQuery?: string;
}
/**
 *
 * @export
 * @interface ShadowTestResponse
 */
export interface ShadowTestResponse {
  /**
   * Status message of the shadow test initiation
   * @type {string}
   * @memberof ShadowTestResponse
   */
  message: string;
  /**
   * The ARN of the Step Function execution
   * @type {string}
   * @memberof ShadowTestResponse
   */
  executionArn: string;
  /**
   * Number of orders included in the shadow test
   * @type {number}
   * @memberof ShadowTestResponse
   */
  transactionsCount: number;
}
/**
 *
 * @export
 * @interface Transaction
 */
export interface Transaction {
  /**
   * Either AUID or OrderId depending on GL code
   * @type {string}
   * @memberof Transaction
   */
  id: string;
  /**
   * Environment (Prod, Gamma, Beta)
   * @type {string}
   * @memberof Transaction
   */
  stage: TransactionStageEnum;
  /**
   * Country code (e.g., US, GB, DE)
   * @type {string}
   * @memberof Transaction
   */
  country: string;
  /**
   * GL code (e.g., 318, 613)
   * @type {string}
   * @memberof Transaction
   */
  gl: string;
  /**
   * Time when the transaction was processed
   * @type {string}
   * @memberof Transaction
   */
  processedTime: string;
  /**
   * Simplified transaction type
   * @type {string}
   * @memberof Transaction
   */
  usecase: string;
  /**
   * Payment method used for the transaction
   * @type {string}
   * @memberof Transaction
   */
  paymentMethod: string;
  /**
   * Consumption Type for the transaction
   * @type {string}
   * @memberof Transaction
   */
  consumptionType: string;
}

export const TransactionStageEnum = {
  Prod: "Prod",
  Gamma: "Gamma",
  Beta: "Beta",
} as const;

export type TransactionStageEnum =
  (typeof TransactionStageEnum)[keyof typeof TransactionStageEnum];

/**
 *
 * @export
 * @interface TransactionCreate
 */
export interface TransactionCreate {
  /**
   *
   * @type {string}
   * @memberof TransactionCreate
   */
  transactionId: string;
  /**
   *
   * @type {string}
   * @memberof TransactionCreate
   */
  assignedTo?: string;
  /**
   *
   * @type {number}
   * @memberof TransactionCreate
   */
  version: number;
}
/**
 *
 * @export
 * @interface TransactionUpdate
 */
export interface TransactionUpdate {
  /**
   *
   * @type {string}
   * @memberof TransactionUpdate
   */
  txnStatus?: string;
  /**
   *
   * @type {string}
   * @memberof TransactionUpdate
   */
  uatStatus?: string;
  /**
   *
   * @type {string}
   * @memberof TransactionUpdate
   */
  assignedTo?: string;
  /**
   *
   * @type {number}
   * @memberof TransactionUpdate
   */
  version: number;
}

/**
 * CbesApi - axios parameter creator
 * @export
 */
export const CbesApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary List of cbe\'s
     * @param {string} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCbes: async (
      stage: string,
      orderId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'stage' is not null or undefined
      assertParamExists("getCbes", "stage", stage);
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("getCbes", "orderId", orderId);
      const localVarPath = `/cbes`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (stage !== undefined) {
        localVarQueryParameter["stage"] = stage;
      }

      if (orderId !== undefined) {
        localVarQueryParameter["orderId"] = orderId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List of CBEs and events
     * @param {string} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDetails: async (
      stage: string,
      orderId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'stage' is not null or undefined
      assertParamExists("getDetails", "stage", stage);
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("getDetails", "orderId", orderId);
      const localVarPath = `/details`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (stage !== undefined) {
        localVarQueryParameter["stage"] = stage;
      }

      if (orderId !== undefined) {
        localVarQueryParameter["orderId"] = orderId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CbesApi - functional programming interface
 * @export
 */
export const CbesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = CbesApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary List of cbe\'s
     * @param {string} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCbes(
      stage: string,
      orderId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Cbe>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCbes(
        stage,
        orderId,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary List of CBEs and events
     * @param {string} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDetails(
      stage: string,
      orderId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DetailsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getDetails(
        stage,
        orderId,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * CbesApi - factory interface
 * @export
 */
export const CbesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = CbesApiFp(configuration);
  return {
    /**
     *
     * @summary List of cbe\'s
     * @param {string} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCbes(
      stage: string,
      orderId: string,
      options?: any
    ): AxiosPromise<Array<Cbe>> {
      return localVarFp
        .getCbes(stage, orderId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List of CBEs and events
     * @param {string} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDetails(
      stage: string,
      orderId: string,
      options?: any
    ): AxiosPromise<DetailsResponse> {
      return localVarFp
        .getDetails(stage, orderId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * CbesApi - object-oriented interface
 * @export
 * @class CbesApi
 * @extends {BaseAPI}
 */
export class CbesApi extends BaseAPI {
  /**
   *
   * @summary List of cbe\'s
   * @param {string} stage environment name
   * @param {string} orderId ID of the order
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CbesApi
   */
  public getCbes(stage: string, orderId: string, options?: AxiosRequestConfig) {
    return CbesApiFp(this.configuration)
      .getCbes(stage, orderId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List of CBEs and events
   * @param {string} stage environment name
   * @param {string} orderId ID of the order
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CbesApi
   */
  public getDetails(
    stage: string,
    orderId: string,
    options?: AxiosRequestConfig
  ) {
    return CbesApiFp(this.configuration)
      .getDetails(stage, orderId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * DashboardApi - axios parameter creator
 * @export
 */
export const DashboardApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Get QuickSight dashboard embed URL
     * @param {string} stage environment name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDashboardEmbedUrl: async (
      stage: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'stage' is not null or undefined
      assertParamExists("getDashboardEmbedUrl", "stage", stage);
      const localVarPath = `/dashboard`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (stage !== undefined) {
        localVarQueryParameter["stage"] = stage;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DashboardApi - functional programming interface
 * @export
 */
export const DashboardApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    DashboardApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get QuickSight dashboard embed URL
     * @param {string} stage environment name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDashboardEmbedUrl(
      stage: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DashboardEmbedResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getDashboardEmbedUrl(stage, options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * DashboardApi - factory interface
 * @export
 */
export const DashboardApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = DashboardApiFp(configuration);
  return {
    /**
     *
     * @summary Get QuickSight dashboard embed URL
     * @param {string} stage environment name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDashboardEmbedUrl(
      stage: string,
      options?: any
    ): AxiosPromise<DashboardEmbedResponse> {
      return localVarFp
        .getDashboardEmbedUrl(stage, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * DashboardApi - object-oriented interface
 * @export
 * @class DashboardApi
 * @extends {BaseAPI}
 */
export class DashboardApi extends BaseAPI {
  /**
   *
   * @summary Get QuickSight dashboard embed URL
   * @param {string} stage environment name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DashboardApi
   */
  public getDashboardEmbedUrl(stage: string, options?: AxiosRequestConfig) {
    return DashboardApiFp(this.configuration)
      .getDashboardEmbedUrl(stage, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * DlqApi - axios parameter creator
 * @export
 */
export const DlqApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Check DLQ status and get details for a transaction
     * @param {string} stage environment name
     * @param {string} [orderId] ID of the transaction to check
     * @param {string} [queryExecutionId] ID of the query execution
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDLQInfo: async (
      stage: string,
      orderId?: string,
      queryExecutionId?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'stage' is not null or undefined
      assertParamExists("getDLQInfo", "stage", stage);
      const localVarPath = `/dlq-info`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (stage !== undefined) {
        localVarQueryParameter["stage"] = stage;
      }

      if (orderId !== undefined) {
        localVarQueryParameter["orderId"] = orderId;
      }

      if (queryExecutionId !== undefined) {
        localVarQueryParameter["queryExecutionId"] = queryExecutionId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DlqApi - functional programming interface
 * @export
 */
export const DlqApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DlqApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Check DLQ status and get details for a transaction
     * @param {string} stage environment name
     * @param {string} [orderId] ID of the transaction to check
     * @param {string} [queryExecutionId] ID of the query execution
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDLQInfo(
      stage: string,
      orderId?: string,
      queryExecutionId?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<DLQInfoResult>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getDLQInfo(
        stage,
        orderId,
        queryExecutionId,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * DlqApi - factory interface
 * @export
 */
export const DlqApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = DlqApiFp(configuration);
  return {
    /**
     *
     * @summary Check DLQ status and get details for a transaction
     * @param {string} stage environment name
     * @param {string} [orderId] ID of the transaction to check
     * @param {string} [queryExecutionId] ID of the query execution
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDLQInfo(
      stage: string,
      orderId?: string,
      queryExecutionId?: string,
      options?: any
    ): AxiosPromise<DLQInfoResult> {
      return localVarFp
        .getDLQInfo(stage, orderId, queryExecutionId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * DlqApi - object-oriented interface
 * @export
 * @class DlqApi
 * @extends {BaseAPI}
 */
export class DlqApi extends BaseAPI {
  /**
   *
   * @summary Check DLQ status and get details for a transaction
   * @param {string} stage environment name
   * @param {string} [orderId] ID of the transaction to check
   * @param {string} [queryExecutionId] ID of the query execution
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DlqApi
   */
  public getDLQInfo(
    stage: string,
    orderId?: string,
    queryExecutionId?: string,
    options?: AxiosRequestConfig
  ) {
    return DlqApiFp(this.configuration)
      .getDLQInfo(stage, orderId, queryExecutionId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * DlqRedriveApi - axios parameter creator
 * @export
 */
export const DlqRedriveApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Start and check DLQ redrive status
     * @param {string} stage environment name
     * @param {Array<string>} [messageIds] ID of the transaction to check
     * @param {string} [executionArn] Arn of the query execution
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDLQRedriveInfo: async (
      stage: string,
      messageIds?: Array<string>,
      executionArn?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'stage' is not null or undefined
      assertParamExists("getDLQRedriveInfo", "stage", stage);
      const localVarPath = `/dlq-redrive-info`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (stage !== undefined) {
        localVarQueryParameter["stage"] = stage;
      }

      if (messageIds) {
        localVarQueryParameter["messageIds"] = messageIds;
      }

      if (executionArn !== undefined) {
        localVarQueryParameter["executionArn"] = executionArn;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DlqRedriveApi - functional programming interface
 * @export
 */
export const DlqRedriveApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    DlqRedriveApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Start and check DLQ redrive status
     * @param {string} stage environment name
     * @param {Array<string>} [messageIds] ID of the transaction to check
     * @param {string} [executionArn] Arn of the query execution
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDLQRedriveInfo(
      stage: string,
      messageIds?: Array<string>,
      executionArn?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DLQRedriveInfoResult>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getDLQRedriveInfo(
          stage,
          messageIds,
          executionArn,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * DlqRedriveApi - factory interface
 * @export
 */
export const DlqRedriveApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = DlqRedriveApiFp(configuration);
  return {
    /**
     *
     * @summary Start and check DLQ redrive status
     * @param {string} stage environment name
     * @param {Array<string>} [messageIds] ID of the transaction to check
     * @param {string} [executionArn] Arn of the query execution
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDLQRedriveInfo(
      stage: string,
      messageIds?: Array<string>,
      executionArn?: string,
      options?: any
    ): AxiosPromise<DLQRedriveInfoResult> {
      return localVarFp
        .getDLQRedriveInfo(stage, messageIds, executionArn, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * DlqRedriveApi - object-oriented interface
 * @export
 * @class DlqRedriveApi
 * @extends {BaseAPI}
 */
export class DlqRedriveApi extends BaseAPI {
  /**
   *
   * @summary Start and check DLQ redrive status
   * @param {string} stage environment name
   * @param {Array<string>} [messageIds] ID of the transaction to check
   * @param {string} [executionArn] Arn of the query execution
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DlqRedriveApi
   */
  public getDLQRedriveInfo(
    stage: string,
    messageIds?: Array<string>,
    executionArn?: string,
    options?: AxiosRequestConfig
  ) {
    return DlqRedriveApiFp(this.configuration)
      .getDLQRedriveInfo(stage, messageIds, executionArn, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * DownloadS3FileApi - axios parameter creator
 * @export
 */
export const DownloadS3FileApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Download S3 File
     * @param {string} key file name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    download: async (
      key: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'key' is not null or undefined
      assertParamExists("download", "key", key);
      const localVarPath = `/download`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (key !== undefined) {
        localVarQueryParameter["key"] = key;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * DownloadS3FileApi - functional programming interface
 * @export
 */
export const DownloadS3FileApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    DownloadS3FileApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Download S3 File
     * @param {string} key file name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async download(
      key: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DownloadS3FileResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.download(
        key,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * DownloadS3FileApi - factory interface
 * @export
 */
export const DownloadS3FileApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = DownloadS3FileApiFp(configuration);
  return {
    /**
     *
     * @summary Download S3 File
     * @param {string} key file name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    download(key: string, options?: any): AxiosPromise<DownloadS3FileResponse> {
      return localVarFp
        .download(key, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * DownloadS3FileApi - object-oriented interface
 * @export
 * @class DownloadS3FileApi
 * @extends {BaseAPI}
 */
export class DownloadS3FileApi extends BaseAPI {
  /**
   *
   * @summary Download S3 File
   * @param {string} key file name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DownloadS3FileApi
   */
  public download(key: string, options?: AxiosRequestConfig) {
    return DownloadS3FileApiFp(this.configuration)
      .download(key, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * EventsApi - axios parameter creator
 * @export
 */
export const EventsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary List of CBEs and events
     * @param {string} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDetails: async (
      stage: string,
      orderId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'stage' is not null or undefined
      assertParamExists("getDetails", "stage", stage);
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("getDetails", "orderId", orderId);
      const localVarPath = `/details`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (stage !== undefined) {
        localVarQueryParameter["stage"] = stage;
      }

      if (orderId !== undefined) {
        localVarQueryParameter["orderId"] = orderId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List of events with different versions
     * @param {string} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEvents: async (
      stage: string,
      orderId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'stage' is not null or undefined
      assertParamExists("getEvents", "stage", stage);
      // verify required parameter 'orderId' is not null or undefined
      assertParamExists("getEvents", "orderId", orderId);
      const localVarPath = `/events`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (stage !== undefined) {
        localVarQueryParameter["stage"] = stage;
      }

      if (orderId !== undefined) {
        localVarQueryParameter["orderId"] = orderId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary List of CBEs and events
     * @param {string} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDetails(
      stage: string,
      orderId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DetailsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getDetails(
        stage,
        orderId,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary List of events with different versions
     * @param {string} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEvents(
      stage: string,
      orderId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Event>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getEvents(
        stage,
        orderId,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = EventsApiFp(configuration);
  return {
    /**
     *
     * @summary List of CBEs and events
     * @param {string} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDetails(
      stage: string,
      orderId: string,
      options?: any
    ): AxiosPromise<DetailsResponse> {
      return localVarFp
        .getDetails(stage, orderId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List of events with different versions
     * @param {string} stage environment name
     * @param {string} orderId ID of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEvents(
      stage: string,
      orderId: string,
      options?: any
    ): AxiosPromise<Array<Event>> {
      return localVarFp
        .getEvents(stage, orderId, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI {
  /**
   *
   * @summary List of CBEs and events
   * @param {string} stage environment name
   * @param {string} orderId ID of the order
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public getDetails(
    stage: string,
    orderId: string,
    options?: AxiosRequestConfig
  ) {
    return EventsApiFp(this.configuration)
      .getDetails(stage, orderId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List of events with different versions
   * @param {string} stage environment name
   * @param {string} orderId ID of the order
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof EventsApi
   */
  public getEvents(
    stage: string,
    orderId: string,
    options?: AxiosRequestConfig
  ) {
    return EventsApiFp(this.configuration)
      .getEvents(stage, orderId, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ProjectsApi - axios parameter creator
 * @export
 */
export const ProjectsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Add a transaction to a project
     * @param {string} projectId
     * @param {TransactionCreate} transactionCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addTransaction: async (
      projectId: string,
      transactionCreate: TransactionCreate,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("addTransaction", "projectId", projectId);
      // verify required parameter 'transactionCreate' is not null or undefined
      assertParamExists(
        "addTransaction",
        "transactionCreate",
        transactionCreate
      );
      const localVarPath = `/projects/{projectId}/transactions`.replace(
        `{${"projectId"}}`,
        encodeURIComponent(String(projectId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        transactionCreate,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create a new UAT project
     * @param {ProjectCreate} projectCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createProject: async (
      projectCreate: ProjectCreate,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectCreate' is not null or undefined
      assertParamExists("createProject", "projectCreate", projectCreate);
      const localVarPath = `/projects`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectCreate,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a specific project
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProject: async (
      projectId: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("getProject", "projectId", projectId);
      const localVarPath = `/projects/{projectId}`.replace(
        `{${"projectId"}}`,
        encodeURIComponent(String(projectId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary List all UAT projects
     * @param {boolean} [includeArchived]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listProjects: async (
      includeArchived?: boolean,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/projects`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (includeArchived !== undefined) {
        localVarQueryParameter["includeArchived"] = includeArchived;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a project
     * @param {string} projectId
     * @param {ProjectUpdate} projectUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProject: async (
      projectId: string,
      projectUpdate: ProjectUpdate,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("updateProject", "projectId", projectId);
      // verify required parameter 'projectUpdate' is not null or undefined
      assertParamExists("updateProject", "projectUpdate", projectUpdate);
      const localVarPath = `/projects/{projectId}`.replace(
        `{${"projectId"}}`,
        encodeURIComponent(String(projectId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        projectUpdate,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a transaction in a project
     * @param {string} projectId
     * @param {string} transactionId
     * @param {TransactionUpdate} transactionUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTransaction: async (
      projectId: string,
      transactionId: string,
      transactionUpdate: TransactionUpdate,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("updateTransaction", "projectId", projectId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists("updateTransaction", "transactionId", transactionId);
      // verify required parameter 'transactionUpdate' is not null or undefined
      assertParamExists(
        "updateTransaction",
        "transactionUpdate",
        transactionUpdate
      );
      const localVarPath = `/projects/{projectId}/transactions/{transactionId}`
        .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
        .replace(
          `{${"transactionId"}}`,
          encodeURIComponent(String(transactionId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        transactionUpdate,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ProjectsApi - functional programming interface
 * @export
 */
export const ProjectsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ProjectsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Add a transaction to a project
     * @param {string} projectId
     * @param {TransactionCreate} transactionCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addTransaction(
      projectId: string,
      transactionCreate: TransactionCreate,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addTransaction(
        projectId,
        transactionCreate,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Create a new UAT project
     * @param {ProjectCreate} projectCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createProject(
      projectCreate: ProjectCreate,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createProject(
        projectCreate,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Get a specific project
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getProject(
      projectId: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getProject(
        projectId,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary List all UAT projects
     * @param {boolean} [includeArchived]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async listProjects(
      includeArchived?: boolean,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ListProjects200Response>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.listProjects(
        includeArchived,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Update a project
     * @param {string} projectId
     * @param {ProjectUpdate} projectUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateProject(
      projectId: string,
      projectUpdate: ProjectUpdate,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateProject(
        projectId,
        projectUpdate,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Update a transaction in a project
     * @param {string} projectId
     * @param {string} transactionId
     * @param {TransactionUpdate} transactionUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateTransaction(
      projectId: string,
      transactionId: string,
      transactionUpdate: TransactionUpdate,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateTransaction(
          projectId,
          transactionId,
          transactionUpdate,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ProjectsApi - factory interface
 * @export
 */
export const ProjectsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ProjectsApiFp(configuration);
  return {
    /**
     *
     * @summary Add a transaction to a project
     * @param {string} projectId
     * @param {TransactionCreate} transactionCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addTransaction(
      projectId: string,
      transactionCreate: TransactionCreate,
      options?: any
    ): AxiosPromise<Project> {
      return localVarFp
        .addTransaction(projectId, transactionCreate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create a new UAT project
     * @param {ProjectCreate} projectCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createProject(
      projectCreate: ProjectCreate,
      options?: any
    ): AxiosPromise<Project> {
      return localVarFp
        .createProject(projectCreate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a specific project
     * @param {string} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProject(projectId: string, options?: any): AxiosPromise<Project> {
      return localVarFp
        .getProject(projectId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary List all UAT projects
     * @param {boolean} [includeArchived]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    listProjects(
      includeArchived?: boolean,
      options?: any
    ): AxiosPromise<ListProjects200Response> {
      return localVarFp
        .listProjects(includeArchived, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a project
     * @param {string} projectId
     * @param {ProjectUpdate} projectUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProject(
      projectId: string,
      projectUpdate: ProjectUpdate,
      options?: any
    ): AxiosPromise<Project> {
      return localVarFp
        .updateProject(projectId, projectUpdate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a transaction in a project
     * @param {string} projectId
     * @param {string} transactionId
     * @param {TransactionUpdate} transactionUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTransaction(
      projectId: string,
      transactionId: string,
      transactionUpdate: TransactionUpdate,
      options?: any
    ): AxiosPromise<Project> {
      return localVarFp
        .updateTransaction(projectId, transactionId, transactionUpdate, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ProjectsApi - object-oriented interface
 * @export
 * @class ProjectsApi
 * @extends {BaseAPI}
 */
export class ProjectsApi extends BaseAPI {
  /**
   *
   * @summary Add a transaction to a project
   * @param {string} projectId
   * @param {TransactionCreate} transactionCreate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public addTransaction(
    projectId: string,
    transactionCreate: TransactionCreate,
    options?: AxiosRequestConfig
  ) {
    return ProjectsApiFp(this.configuration)
      .addTransaction(projectId, transactionCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create a new UAT project
   * @param {ProjectCreate} projectCreate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public createProject(
    projectCreate: ProjectCreate,
    options?: AxiosRequestConfig
  ) {
    return ProjectsApiFp(this.configuration)
      .createProject(projectCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a specific project
   * @param {string} projectId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public getProject(projectId: string, options?: AxiosRequestConfig) {
    return ProjectsApiFp(this.configuration)
      .getProject(projectId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary List all UAT projects
   * @param {boolean} [includeArchived]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public listProjects(includeArchived?: boolean, options?: AxiosRequestConfig) {
    return ProjectsApiFp(this.configuration)
      .listProjects(includeArchived, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a project
   * @param {string} projectId
   * @param {ProjectUpdate} projectUpdate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public updateProject(
    projectId: string,
    projectUpdate: ProjectUpdate,
    options?: AxiosRequestConfig
  ) {
    return ProjectsApiFp(this.configuration)
      .updateProject(projectId, projectUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a transaction in a project
   * @param {string} projectId
   * @param {string} transactionId
   * @param {TransactionUpdate} transactionUpdate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProjectsApi
   */
  public updateTransaction(
    projectId: string,
    transactionId: string,
    transactionUpdate: TransactionUpdate,
    options?: AxiosRequestConfig
  ) {
    return ProjectsApiFp(this.configuration)
      .updateTransaction(projectId, transactionId, transactionUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * ShadowTestApi - axios parameter creator
 * @export
 */
export const ShadowTestApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Trigger a shadow test for a list of transactions
     * @param {string} stage environment name (prod, beta, etc)
     * @param {CreateShadowTestRequest} createShadowTestRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createShadowTest: async (
      stage: string,
      createShadowTestRequest: CreateShadowTestRequest,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'stage' is not null or undefined
      assertParamExists("createShadowTest", "stage", stage);
      // verify required parameter 'createShadowTestRequest' is not null or undefined
      assertParamExists(
        "createShadowTest",
        "createShadowTestRequest",
        createShadowTestRequest
      );
      const localVarPath = `/shadow-test`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (stage !== undefined) {
        localVarQueryParameter["stage"] = stage;
      }

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        createShadowTestRequest,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ShadowTestApi - functional programming interface
 * @export
 */
export const ShadowTestApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    ShadowTestApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Trigger a shadow test for a list of transactions
     * @param {string} stage environment name (prod, beta, etc)
     * @param {CreateShadowTestRequest} createShadowTestRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createShadowTest(
      stage: string,
      createShadowTestRequest: CreateShadowTestRequest,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<ShadowTestResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createShadowTest(
          stage,
          createShadowTestRequest,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * ShadowTestApi - factory interface
 * @export
 */
export const ShadowTestApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = ShadowTestApiFp(configuration);
  return {
    /**
     *
     * @summary Trigger a shadow test for a list of transactions
     * @param {string} stage environment name (prod, beta, etc)
     * @param {CreateShadowTestRequest} createShadowTestRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createShadowTest(
      stage: string,
      createShadowTestRequest: CreateShadowTestRequest,
      options?: any
    ): AxiosPromise<ShadowTestResponse> {
      return localVarFp
        .createShadowTest(stage, createShadowTestRequest, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * ShadowTestApi - object-oriented interface
 * @export
 * @class ShadowTestApi
 * @extends {BaseAPI}
 */
export class ShadowTestApi extends BaseAPI {
  /**
   *
   * @summary Trigger a shadow test for a list of transactions
   * @param {string} stage environment name (prod, beta, etc)
   * @param {CreateShadowTestRequest} createShadowTestRequest
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ShadowTestApi
   */
  public createShadowTest(
    stage: string,
    createShadowTestRequest: CreateShadowTestRequest,
    options?: AxiosRequestConfig
  ) {
    return ShadowTestApiFp(this.configuration)
      .createShadowTest(stage, createShadowTestRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * TransactionsApi - axios parameter creator
 * @export
 */
export const TransactionsApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Add a transaction to a project
     * @param {string} projectId
     * @param {TransactionCreate} transactionCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addTransaction: async (
      projectId: string,
      transactionCreate: TransactionCreate,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("addTransaction", "projectId", projectId);
      // verify required parameter 'transactionCreate' is not null or undefined
      assertParamExists(
        "addTransaction",
        "transactionCreate",
        transactionCreate
      );
      const localVarPath = `/projects/{projectId}/transactions`.replace(
        `{${"projectId"}}`,
        encodeURIComponent(String(projectId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "POST",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        transactionCreate,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get recent transactions across regions
     * @param {string} stage environment name
     * @param {Array<string>} [countries] country codes to filter by (e.g., US, GB, DE)
     * @param {string} [gl] GL code to filter by (e.g., 318, 613)
     * @param {Array<string>} [usecases] usecase types to filter by
     * @param {string} [paymentMethod] filter for payment methods
     * @param {number} [endTime] timestamp for pagination
     * @param {Array<string>} [consumptionTypes] consumption type to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRecentTransactions: async (
      stage: string,
      countries?: Array<string>,
      gl?: string,
      usecases?: Array<string>,
      paymentMethod?: string,
      endTime?: number,
      consumptionTypes?: Array<string>,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'stage' is not null or undefined
      assertParamExists("getRecentTransactions", "stage", stage);
      const localVarPath = `/recent-transactions`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "GET",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (stage !== undefined) {
        localVarQueryParameter["stage"] = stage;
      }

      if (countries) {
        localVarQueryParameter["countries"] = countries;
      }

      if (gl !== undefined) {
        localVarQueryParameter["gl"] = gl;
      }

      if (usecases) {
        localVarQueryParameter["usecases"] = usecases;
      }

      if (paymentMethod !== undefined) {
        localVarQueryParameter["paymentMethod"] = paymentMethod;
      }

      if (endTime !== undefined) {
        localVarQueryParameter["endTime"] = endTime;
      }

      if (consumptionTypes) {
        localVarQueryParameter["consumptionTypes"] = consumptionTypes;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a transaction in a project
     * @param {string} projectId
     * @param {string} transactionId
     * @param {TransactionUpdate} transactionUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTransaction: async (
      projectId: string,
      transactionId: string,
      transactionUpdate: TransactionUpdate,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("updateTransaction", "projectId", projectId);
      // verify required parameter 'transactionId' is not null or undefined
      assertParamExists("updateTransaction", "transactionId", transactionId);
      // verify required parameter 'transactionUpdate' is not null or undefined
      assertParamExists(
        "updateTransaction",
        "transactionUpdate",
        transactionUpdate
      );
      const localVarPath = `/projects/{projectId}/transactions/{transactionId}`
        .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
        .replace(
          `{${"transactionId"}}`,
          encodeURIComponent(String(transactionId))
        );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: "PUT",
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        transactionUpdate,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TransactionsApi - functional programming interface
 * @export
 */
export const TransactionsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    TransactionsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Add a transaction to a project
     * @param {string} projectId
     * @param {TransactionCreate} transactionCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async addTransaction(
      projectId: string,
      transactionCreate: TransactionCreate,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.addTransaction(
        projectId,
        transactionCreate,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Get recent transactions across regions
     * @param {string} stage environment name
     * @param {Array<string>} [countries] country codes to filter by (e.g., US, GB, DE)
     * @param {string} [gl] GL code to filter by (e.g., 318, 613)
     * @param {Array<string>} [usecases] usecase types to filter by
     * @param {string} [paymentMethod] filter for payment methods
     * @param {number} [endTime] timestamp for pagination
     * @param {Array<string>} [consumptionTypes] consumption type to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getRecentTransactions(
      stage: string,
      countries?: Array<string>,
      gl?: string,
      usecases?: Array<string>,
      paymentMethod?: string,
      endTime?: number,
      consumptionTypes?: Array<string>,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<RecentTransactionsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getRecentTransactions(
          stage,
          countries,
          gl,
          usecases,
          paymentMethod,
          endTime,
          consumptionTypes,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @summary Update a transaction in a project
     * @param {string} projectId
     * @param {string} transactionId
     * @param {TransactionUpdate} transactionUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateTransaction(
      projectId: string,
      transactionId: string,
      transactionUpdate: TransactionUpdate,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Project>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateTransaction(
          projectId,
          transactionId,
          transactionUpdate,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
  };
};

/**
 * TransactionsApi - factory interface
 * @export
 */
export const TransactionsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TransactionsApiFp(configuration);
  return {
    /**
     *
     * @summary Add a transaction to a project
     * @param {string} projectId
     * @param {TransactionCreate} transactionCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addTransaction(
      projectId: string,
      transactionCreate: TransactionCreate,
      options?: any
    ): AxiosPromise<Project> {
      return localVarFp
        .addTransaction(projectId, transactionCreate, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get recent transactions across regions
     * @param {string} stage environment name
     * @param {Array<string>} [countries] country codes to filter by (e.g., US, GB, DE)
     * @param {string} [gl] GL code to filter by (e.g., 318, 613)
     * @param {Array<string>} [usecases] usecase types to filter by
     * @param {string} [paymentMethod] filter for payment methods
     * @param {number} [endTime] timestamp for pagination
     * @param {Array<string>} [consumptionTypes] consumption type to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getRecentTransactions(
      stage: string,
      countries?: Array<string>,
      gl?: string,
      usecases?: Array<string>,
      paymentMethod?: string,
      endTime?: number,
      consumptionTypes?: Array<string>,
      options?: any
    ): AxiosPromise<RecentTransactionsResponse> {
      return localVarFp
        .getRecentTransactions(
          stage,
          countries,
          gl,
          usecases,
          paymentMethod,
          endTime,
          consumptionTypes,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a transaction in a project
     * @param {string} projectId
     * @param {string} transactionId
     * @param {TransactionUpdate} transactionUpdate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTransaction(
      projectId: string,
      transactionId: string,
      transactionUpdate: TransactionUpdate,
      options?: any
    ): AxiosPromise<Project> {
      return localVarFp
        .updateTransaction(projectId, transactionId, transactionUpdate, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * TransactionsApi - object-oriented interface
 * @export
 * @class TransactionsApi
 * @extends {BaseAPI}
 */
export class TransactionsApi extends BaseAPI {
  /**
   *
   * @summary Add a transaction to a project
   * @param {string} projectId
   * @param {TransactionCreate} transactionCreate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsApi
   */
  public addTransaction(
    projectId: string,
    transactionCreate: TransactionCreate,
    options?: AxiosRequestConfig
  ) {
    return TransactionsApiFp(this.configuration)
      .addTransaction(projectId, transactionCreate, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get recent transactions across regions
   * @param {string} stage environment name
   * @param {Array<string>} [countries] country codes to filter by (e.g., US, GB, DE)
   * @param {string} [gl] GL code to filter by (e.g., 318, 613)
   * @param {Array<string>} [usecases] usecase types to filter by
   * @param {string} [paymentMethod] filter for payment methods
   * @param {number} [endTime] timestamp for pagination
   * @param {Array<string>} [consumptionTypes] consumption type to filter by
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsApi
   */
  public getRecentTransactions(
    stage: string,
    countries?: Array<string>,
    gl?: string,
    usecases?: Array<string>,
    paymentMethod?: string,
    endTime?: number,
    consumptionTypes?: Array<string>,
    options?: AxiosRequestConfig
  ) {
    return TransactionsApiFp(this.configuration)
      .getRecentTransactions(
        stage,
        countries,
        gl,
        usecases,
        paymentMethod,
        endTime,
        consumptionTypes,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a transaction in a project
   * @param {string} projectId
   * @param {string} transactionId
   * @param {TransactionUpdate} transactionUpdate
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionsApi
   */
  public updateTransaction(
    projectId: string,
    transactionId: string,
    transactionUpdate: TransactionUpdate,
    options?: AxiosRequestConfig
  ) {
    return TransactionsApiFp(this.configuration)
      .updateTransaction(projectId, transactionId, transactionUpdate, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
